<script lang="ts">
    import { getTypedContext } from "@lib/svelte-typed-context";
    import { onMount } from "svelte";

    import { formManagerToken } from "./context_tokens";
    import type FormFieldCustomEvent from "./FormFieldCustomEvent";

    export let name: string;
    export let defaultValue: unknown = undefined;

    const formManager = getTypedContext(formManagerToken);

    const value$ = formManager.selectValue(name);
    const errors$ = formManager.selectError(name);
    const onChange = (event: FormFieldCustomEvent) => {
        formManager.updateValue(name, event.detail.value);
    };

    onMount(() => {
        const unregister = formManager.register({ name }, defaultValue);
        return () => unregister();
    });

    $: field = {
        value: $value$,
        errors: $errors$,
        onChange,
        name,
    };
</script>

<slot {field} />
